import { Col, Row, Spin } from "antd";
import { Power3, TweenMax } from "gsap";
import hoverEffect from "hover-effect";
import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { AnimationTime, CareerText, NameText } from "../App.constant";
import Distort from "../assets/images/distort1.jpg";
import CareerImage from "../assets/images/fullstack.png";
import NameImage from "../assets/images/namer.png";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";

const Projects = lazy(() => import("./Projects"));

const Home = (props) => {
  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();

  const [state, setState] = useState({
    welcomeText: NameText,
    isActive: false,
  });
  const container = useRef();

  const logoRef = useRef(null);
  const textRef = useRef(null);
  const heroRef = useRef(null);
  const pitchText = useRef(null);

  const onMouseEnter = (e) => {
    clearAllIntervals();
  };

  const clearAllIntervals = () => {
    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    const timer_id = window.setTimeout(() => {}, Number.MAX_SAFE_INTEGER);

    // Clear any timeout/interval up to that id
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }

    for (let i = 1; i < timer_id; i++) {
      window.clearTimeout(i);
    }
  };

  const onMouseLeave = (e) => {
    animation();
  };

  const animation = () => {
    setInterval(() => {
      const event = new MouseEvent("mouseenter", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      setState({ ...state, welcomeText: CareerText });
      TweenMax.fromTo(
        pitchText.current,
        AnimationTime - 0.5,
        { opacity: 0, y: 0, ease: Power3.easeInOut },
        { opacity: 1, y: -20, ease: Power3.easeInOut }
      ).play();
      document.getElementsByTagName("canvas")[0].dispatchEvent(event);
      setTimeout(() => {
        const leaveEvent = new MouseEvent("mouseleave", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        setState({ ...state, welcomeText: NameText });
        TweenMax.fromTo(
          pitchText.current,
          AnimationTime - 0.5,
          { opacity: 0, y: 0, ease: Power3.easeInOut },
          { opacity: 1, y: -20, ease: Power3.easeInOut }
        ).play();
        document.getElementsByTagName("canvas")[0].dispatchEvent(leaveEvent);
      }, 3000);
    }, 6000);
  };

  useEffect(() => {
    try {
      animation();

      TweenMax.to(logoRef.current, AnimationTime, {
        opacity: 1,
        y: -20,
        ease: Power3.easeInOut,
      }).play();

      TweenMax.to(textRef.current, AnimationTime, {
        opacity: 1,
        y: -20,
        ease: Power3.easeInOut,
        delay: 0.2,
      }).play();

      TweenMax.to(heroRef.current, AnimationTime, {
        opacity: 1,
        y: -20,
        ease: Power3.easeInOut,
        delay: 0.2,
      }).play();

      return () => {
        clearAllIntervals();
      };
    } catch (e) {
      // console.log(e);
    }
  }, []);

  const location = useLocation();

  useEffect(() => {
    new hoverEffect({
      parent: container.current,
      intensity: 0.3,
      image1: NameImage,
      image2: CareerImage,
      displacementImage: Distort,
    });
  }, [container]);

  useEffect(() => {
    if (window) {
      props?.masterStore?.setSelectedBar(location?.pathname);
    }
  }, [location?.pathname]);
  return (
    <d>
      <div style={{ width: "100%", height: "100%", marginTop: 100 }}>
        <Row align="middle">
          <Col span={24} ref={logoRef} style={{ opacity: 0 }}>
            <center>
              <div
                ref={pitchText}
                style={{
                  fontSize: 16,
                  fontWeight: "500",
                  color: "#FFF",
                  margin: 5,
                  marginBottom: 10,
                  fontFamily: "Baloo 2, cursive",
                }}
              >
                {state.welcomeText}
              </div>
              <div
                className="parent"
                id="imgContainer"
                ref={container}
                style={{
                  width: 300,
                  height: 50,
                }}
              />
            </center>
          </Col>
          <Col span={24}>
            <center
              ref={heroRef}
              style={{
                opacity: 0,
                position: "relative",
                top: isTabletOrMobile ? 0 : 0,
              }}
            >
              <div
                style={{
                  width: isTabletOrMobileDevice ? "90%" : "70%",
                  padding: 10,
                  borderRadius: 20,
                  marginTop: isTabletOrMobileDevice ? 20 : 30,
                  marginBottom: 10,
                  height: isTabletOrMobileDevice ? 250 : 230,
                }}
                className="glass-dark"
              >
                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={20}></Col>
                      <Col span={4}>
                        <div style={{ width: "100%", marginLeft: "25%" }}>
                          <div
                            className="orange-dot"
                            style={{ position: "relative", right: 0 }}
                          ></div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <div
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Baloo 2, cursive",
                        fontWeight: "300",
                        paddingTop: isTabletOrMobileDevice ? 0 : 20,
                      }}
                    >
                      With a strong foundation built over 7 years in software
                      development, I have consistently delivered outstanding
                      results across a wide spectrum of projects. My extensive
                      experience includes collaborating effectively with
                      cross-functional teams, utilizing a deep knowledge of
                      diverse technologies to create exceptional web, mobile,
                      and desktop applications. My unwavering commitment to
                      self-improvement fuels my constant learning and
                      adaptability, allowing me to approach each project with a
                      unique problem-solving perspective. I am dedicated to
                      maintaining a track record of excellence. Thank you for
                      considering my profile.
                    </div>
                  </Col>
                </Row>
              </div>
            </center>
          </Col>
          {isTabletOrMobileDevice ? (
            <Col span={24} style={{ padding: 20 }}>
              <div
                style={{
                  fontFamily: "Permanent Marker, cursive",
                  color: "#FFF",
                  fontSize: 18,
                }}
              >
                Projects
              </div>
              <Suspense
                fallback={
                  <center>
                    <div className="spin">
                      <Spin />
                    </div>
                  </center>
                }
              >
                <Projects
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                />
              </Suspense>
            </Col>
          ) : (
            <Col span={24} style={{ paddingLeft: "15%", paddingRight: "15%" }}>
              <div
                style={{
                  fontFamily: "Permanent Marker, cursive",
                  color: "#FFF",
                  fontSize: 18,
                }}
              >
                Projects
              </div>
              <Suspense
                fallback={
                  <center>
                    <div className="spin">
                      <Spin />
                    </div>
                  </center>
                }
              >
                <Projects
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                />
              </Suspense>
            </Col>
          )}
        </Row>
      </div>
    </d>
  );
};

export default stateWrapper(Home);
